import React from 'react'
import CopyToClipboard from './CopyToClipboard'

export interface InvitationLinkRowProps {
  label: string
  url: string
}

export const InvitationLinkRow: React.FC<InvitationLinkRowProps> = ({ label, url }) => {
  return (
    <div className="flex items-center gap-3">
      <span className="w-fit shrink-0 text-sm font-medium text-gray-700 dark:text-gray-200">{label}</span>
      <div className="flex flex-1 min-w-0">
        <CopyToClipboard textToCopy={url} size={2} tabIndex={-1} className="rounded-r-none shrink-0 z-50" /> 
        <span
          className="flex-1 min-w-0 block bg-white dark:bg-gray-800 rounded-r-md rounded-l-none px-3 font-mono text-xs truncate select-all h-9 leading-9"
          title={url}
        >
          {url}
        </span>
      </div>
    </div>
  )
}

export default InvitationLinkRow
